import angular from 'angular';

angular.module('AaApp.Opp').constant('reportSubscriptionViewTypes', {
    list: 1,
    add: 2,
    edit: 3
});
